import { LsKeys } from 'types';

export const LS_KEYS: LsKeys = {
    appSettings: 'appSettings',
    cookiesSuppressed: 'cookiesSuppressed',
    archivedChapters: 'archivedChapters',
    lastActiveChapter: 'lastActiveChapter',
};
